export default __webpack_public_path__ + "static/media/Component51–12.2e65f537.svg";